import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@emotion/react';
import { ColorModeContext, useMode } from './theme/theme';
import Profile from './components/Profile/Profile';
import ContactMe from './components/ContactMe/ContactMe';
import Projects from './components/Projects/Projects';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { IconButton } from '@mui/material';
import Home from './components/Home/Home';


function App() {
  const [theme, colorMode] = useMode();
  return (
    <ColorModeContext.Provider value={colorMode}>
    <ThemeProvider theme={theme}>
    <div className="App">
      <CssBaseline/>
      <Home/>
      <Profile/>
      <Projects/>
      <ContactMe/>
      <a href="#Home">
      <IconButton id="back-to-top">
        <KeyboardDoubleArrowUpIcon sx={{fontSize:'4rem'}}/>
      </IconButton>
      </a>
    </div>
    </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
